import React from 'react';
import {
  Avatar,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography
} from '@mui/material';
import { MenuItemProps } from '../drawer/BakeasyNavigationDrawer';
import { t } from 'i18next';
import { BLUE_GRAY_50, ORANGE_400, PRIMARY } from '../../constants/Colors';
import { useAppSelector } from '../../redux_store/reduxStore';
import { messagesState } from '../../redux_store/slices/messagesSlice';
import { ordersState } from '../../redux_store/slices/ordersSlice';

export interface BakeasyListProps {
  items: MenuItemProps[];
  dense?: boolean;
  open?: boolean | false;
  onMouseOver?: (event: React.MouseEvent<HTMLDivElement>) => void;
  onMouseOut?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

function BakeasyList(props: BakeasyListProps) {
  let _messagesState: any = useAppSelector(messagesState);
  let _ordersState: any = useAppSelector(ordersState);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  let itemsList = props.items.map((item: MenuItemProps) => {
    return (
      <ListItem
        key={item.id}
        disablePadding
        sx={{
          display: 'block',
          color: selectedIndex === item.id ? PRIMARY : '',
          ':hover': { backgroundColor: BLUE_GRAY_50 }
        }}
      >
        <ListItemButton
          sx={{ paddingX: props?.dense ? 1 : 2.5 }}
          selected={selectedIndex === item.id}
          onMouseOver={(event: React.MouseEvent<HTMLDivElement>) => {
            if (props?.onMouseOver) props?.onMouseOver(event);
          }}
          onMouseOut={(event: React.MouseEvent<HTMLDivElement>) => {
            if (props?.onMouseOut) props?.onMouseOut(event);
          }}
          onClick={(event: React.MouseEvent<HTMLDivElement>) => {
            event.stopPropagation();
            item.onClick(event);
            setSelectedIndex(item.id);
          }}
        >
          <Tooltip title={item.lable}>
            <ListItemIcon
              sx={{
                minWidth: 0,
                marginRight: props?.dense ? 1 : 3,
                color: selectedIndex === item.id ? PRIMARY : ''
              }}
            >
              {item.icon}
            </ListItemIcon>
          </Tooltip>

          <ListItemText>
            <div
              style={{
                fontWeight: selectedIndex === item.id ? 'bolder' : 'normal',
                ...(props?.open && {
                  overflow: 'clip',
                  wordWrap: 'break-word',
                  whiteSpace: 'normal',
                  overflowWrap: 'break-word'
                })
              }}
            >
              {t(item.lable)}
            </div>
          </ListItemText>

          {item?.lable === 'MESSAGES' && _messagesState?.newMessageCount?.count && (
            <Avatar sx={{ backgroundColor: ORANGE_400, width: 22, height: 22 }}>
              <Typography sx={{ fontSize: 14 }}>
                {_messagesState?.newMessageCount?.count}
              </Typography>
            </Avatar>
          )}
          {item?.lable === 'ORDERS' && _ordersState?.newOrderCount?.count !== 0 && (
            <Avatar sx={{ backgroundColor: ORANGE_400, width: 22, height: 22 }}>
              <Typography sx={{ fontSize: 14 }}>{_ordersState?.newOrderCount?.count}</Typography>
            </Avatar>
          )}
        </ListItemButton>
      </ListItem>
    );
  });
  return <List>{itemsList}</List>;
}

export default BakeasyList;
